(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('CommissioneDialogController', CommissioneDialogController);

    CommissioneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Commissione', 'legislature'];

    function CommissioneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Commissione, legislature) {
        var vm = this;

        vm.commissione = entity;
        vm.clear = clear;
        vm.save = save;
        vm.legislature = legislature;
        vm.selectedLegislature = {};
        
        if (vm.commissione.legislature) {
            vm.commissione.legislature.forEach(function(legislatura) {
                vm.selectedLegislature[legislatura] = true;
            });
        }
        
        $scope.$watch('vm.selectedLegislature', function() {
            vm.commissione.legislature = Object.keys(vm.selectedLegislature)
                .filter(function(key) {
                    return vm.selectedLegislature[key];
                });
        }, true);

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.commissione.id !== null) {
                Commissione.update(vm.commissione, onSaveSuccess, onSaveError);
            } else {
                Commissione.save(vm.commissione, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('gestioneAttiApp:commissioneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
